<template>
    <div>
        <MenuMobile />

        <HeaderFull />

        <div class="divider"></div>
        <div class="clear"></div>
        <div class="center main">
            <div class="width100" style="text-align:center;">
                <h3 class="darkblue font30">Oeps..</h3>
                <div class="font24 margin10">
                    Deze pagina is helaas niet beschikbaar.
                </div>
                <div class="font20 margintop20">
                    Heb je een vraag? Wij zijn 7 dagen in de week bereikbaar op
                    het volgende telefoonnummer:
                    <br />
                    <div class="margintop15">
                        <a href="tel:0107200500">010-7200500</a>
                    </div>
                </div>
                <div class="font20 margintop20 marginbottom20">
                    Wil je liever whatsappen? Dat kan op:
                    <a
                            href="https://api.whatsapp.com/send?phone=31615153344"
                            target="_blank"
                    >06 151 533 44</a
                    >
                </div>
                <a
                        style="margin-bottom: 50px;width:100%;"
                        href="/"
                        class="button grootbutton groenbg font16 rounded"
                >Klik hier om verder te gaan&nbsp;&nbsp;&rarr;</a
                >
            </div>
        </div>

        <!--
            <p>Try these instead:
                <input type="text" v-model="cruiseID" placeholder="cruise id"> -
                <router-link :to="{ name: 'Cruise', params: { id: cruiseID } }">Cruisepagina</router-link> -
                <router-link :to="{ name: 'Boeken',  params: { id: cruiseID } }">Boeken</router-link>
            </p>
        -->
        <div class="clear margintop10"></div>

        <Footer2 />
    </div>
</template>

<script>
    import Footer2 from './components/Footer2.vue'
    import HeaderFull from './components/HeaderFull'
    import MenuMobile from './components/MenuMobile.vue'

    export default {
        name: 'NotFound',
        components: {
            MenuMobile,
            HeaderFull,
            Footer2,
        },
        data: function() {
            return { cruiseID: 190009 }
        },
        mounted: function() {
            this.$analytics.trackEvent('Vue 404')
        },
    }
</script>

<style scoped></style>
